import { useState } from 'react'
import { StarAvaliation } from '../Employee/StarAvaliation/StarAvaliation'
import { FaPlus } from 'react-icons/fa'
import { putNewCriterionEmployee } from '../../API/Services/RemuneracionVariable/EmployeeMedia'

export function MediasAccordion({ medias, userId }) {
	const [isLoading, setIsLoading] = useState(false)
	const [openSection, setOpenSection] = useState(null)
	const [newCriterions, setNewCriterions] = useState({
		potential: [],
		performance: [],
	})
	const [inputValue, setInputValue] = useState({
		potential: '',
		performance: '',
	})

	const hasMedia = Array.isArray(medias) && medias.length > 0 && medias[0]
	const safeMedia = hasMedia ? medias[0] : {}
	const { performance = {}, potential = {}, employeeMediaId, evaluationInfo } = safeMedia

	const [localData, setLocalData] = useState({
		potential: Array.isArray(potential.answers) ? potential.answers : [],
		performance: Array.isArray(performance.answers) ? performance.answers : [],
	})

	if (!hasMedia) {
		return <div className='tw-text-gray-400'>Nenhuma média disponível</div>
	}

	const toggleSection = section => {
		setOpenSection(prev => (prev === section ? null : section))
	}

	const handleAddCriterion = section => {
		const input = inputValue[section]?.trim()
		if (!input) return

		const newItem = { name: input, value: null, weight: null }

		setNewCriterions(prev => ({
			...prev,
			[section]: [...prev[section], newItem],
		}))

		setInputValue(prev => ({
			...prev,
			[section]: '',
		}))
	}

	const handleSaveUpdate = async () => {
		const newAnswers = newCriterions.performance || []
		const newPotential = newCriterions.potential || []
		const hasNewAnswers = newAnswers.length > 0
		const hasNewPotential = newPotential.length > 0

		if (!hasNewAnswers && !hasNewPotential) return

		const payload = {
			evaluationId: evaluationInfo?.id,
			employeeId: userId,
		}

		if (hasNewAnswers) {
			payload.answers = [...localData.performance, ...newAnswers]
		}

		if (hasNewPotential) {
			payload.potential = [...localData.potential, ...newPotential]
		}

		try {
			setIsLoading(true)
			await putNewCriterionEmployee(payload, employeeMediaId)

			setLocalData(prev => ({
				performance: payload.answers ?? prev.performance,
				potential: payload.potential ?? prev.potential,
			}))

			setNewCriterions({ potential: [], performance: [] })
		} catch (err) {
			console.error('Erro ao atualizar os critérios:', err)
		} finally {
			setIsLoading(false)
		}
	}

	const renderAnswers = section => {
		const base = localData[section] || []
		const temp = newCriterions[section] || []
		const combined = [...base, ...temp]

		if (combined.length === 0) {
			return <div className='tw-text-center tw-my-4'>Ningún criterio encontrado para esta evaluación.</div>
		}

		return (
			<table className='tw-w-full tw-mt-4'>
				<thead>
					<tr className='tw-text-left tw-text-black'>
						<th className='tw-py-2 tw-font-bold'>{section === 'performance' ? 'Desempeño' : 'Potencial'}</th>
						<th className='tw-py-2 tw-font-bold tw-text-center'>Peso</th>
						<th className='tw-py-2 tw-font-bold tw-text-center'>Logrado (%)</th>
					</tr>
				</thead>
				<tbody>
					{combined.map((item, index) => (
						<tr key={index}>
							<td className='tw-py-4'>{item?.name ?? ' - '}</td>
							<td className='tw-py-4 tw-text-center'>{item?.weight != null ? item.weight : ' - '}</td>
							<td className='tw-py-4 tw-text-center tw-text-black'>{item?.value != null ? `${item.value}%` : ' - '}</td>
						</tr>
					))}
				</tbody>
			</table>
		)
	}

	const hasPendingChanges = section => newCriterions[section]?.length > 0

	const renderSection = (label, sectionKey) => {
		const mediaValue = sectionKey === 'performance' ? performance?.boxValue : potential?.boxValue

		return (
			<div className='border tw-rounded-lg tw-bg-white'>
				<div
					className={`tw-w-full tw-cursor-pointer tw-p-4 tw-font-bold tw-text-left ${
						openSection === sectionKey ? 'tw-text-white tw-bg-purple-500 tw-rounded-t-md' : 'tw-text-purple-600'
					}`}
					onClick={() => toggleSection(sectionKey)}
				>
					<div className='tw-flex tw-items-center tw-justify-between'>
						<span>Evaluación de {label}</span>
						<StarAvaliation isOpen={openSection === sectionKey} label={''} value={mediaValue} eventColorText={openSection === sectionKey} />
					</div>
				</div>

				{openSection === sectionKey && (
					<div className='tw-p-4 tw-space-y-4'>
						{renderAnswers(sectionKey)}

						<div className='tw-flex tw-items-center tw-mt-4 tw-space-x-2'>
							<input
								className='border tw-rounded-lg tw-px-3 tw-py-2 tw-text-base tw-flex-1'
								placeholder='Novo critério'
								value={inputValue[sectionKey] ?? ''}
								onChange={e =>
									setInputValue(prev => ({
										...prev,
										[sectionKey]: e.target.value,
									}))
								}
							/>
							<div
								className={`tw-rounded-full tw-w-7 tw-h-7 tw-flex tw-items-center tw-justify-center ${
									inputValue[sectionKey]?.trim()
										? 'tw-bg-purple-500 tw-text-white tw-cursor-pointer hover:tw-bg-purple-600'
										: 'tw-bg-gray-300 tw-text-gray-500'
								}`}
								onClick={() => {
									if (inputValue[sectionKey]?.trim()) {
										handleAddCriterion(sectionKey)
									}
								}}
							>
								<FaPlus size={12} />
							</div>
						</div>

						{hasPendingChanges(sectionKey) && (
							<div className='tw-flex tw-justify-end tw-space-x-2 tw-mt-4'>
								<div
									className='tw-bg-gray-200 tw-text-gray-800 tw-rounded-full tw-px-4 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-300'
									onClick={() =>
										setNewCriterions(prev => ({
											...prev,
											[sectionKey]: [],
										}))
									}
								>
									Cancelar
								</div>
								<div
									className={`tw-rounded-full tw-px-4 tw-py-2 tw-text-white tw-cursor-pointer ${
										isLoading ? 'tw-bg-gray-200 tw-opacity-70' : 'tw-bg-purple-500 hover:tw-bg-purple-700'
									}`}
									onClick={handleSaveUpdate}
									disabled={isLoading}
								>
									{isLoading ? 'Salvando...' : 'Salvar alterações'}
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		)
	}

	return (
		<div className='tw-w-full tw-space-y-4'>
			{renderSection('Desempeño', 'performance')}
			{renderSection('Potencial', 'potential')}
		</div>
	)
}
